import React from "react";
import campus from "../../../../assets/images/Campus.png"
import hr from "../../../../assets/images/hr.png"
import hospital from "../../../../assets/images/Hospital.png"
import crm from "../../../../assets/images/crm.png"
import inventory from "../../../../assets/images/inventory.png"
import pos from "../../../../assets/images/POS.png"
import { Link } from "react-router-dom";

function Launch() {
  const services = [
    {
      logo: campus,
      title: "Campus Management",
      desc: "Manage academic operations, student data, attendance, and communication in a centralized and efficient system.",
      activeColor: "#6366f1",
      link:"https://bydo.io/campus",
    },
    {
      logo: hr,
      title: "HR Management",
      desc: "Streamline employee records, payroll, recruitment, and performance tracking for better human resource operations.",
      activeColor: "#f59e0b",
      link:"https://bydo.io/hr",
    },
    {
      logo: hospital,
      title: "Hospital Management",
      desc: "Oversee appointments, patient records, billing, and hospital workflows for optimized healthcare delivery.",
      activeColor: "#10b981",
      link:"https://bydo.io/hospital",
    },
    {
      logo: crm,
      title: "CRM Management",
      desc: "Maintain customer relationships, monitor interactions, and boost engagement through organized data and automation.",
      activeColor: "#3b82f6",
      link:"https://bydo.io/crm",
    },
    {
      logo: inventory,
      title: "Inventory Management",
      desc: "Track stock levels, manage supplies, and automate reordering to ensure seamless inventory control.",
      activeColor: "#84cc16",
      link:"https://bydo.io/inventory",
    },
    {
      logo: pos,
      title: "POS Management",
      desc: "Handle sales, track transactions, and manage product data with a smart, user-friendly point of sale system.",
      activeColor: "#f97316",
      link:"https://bydo.io/pos",
    },
  ];

  return (
    <section className="relative py-20 overflow-hidden bg-white">
      {/* Background Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-0 w-80 h-80 bg-purple-100 opacity-30 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-100 opacity-30 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-green-100 opacity-20 rounded-full blur-3xl"></div>
      </div>

      {/* Content Container */}
      <div className="relative z-10 container mx-auto px-4">
        {/* Header Section */}
        <div className="text-center mb-16 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight mb-6">
            From your idea to the
            <span className="text-blue-600"> launch</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We specialize in taking projects from conceptualization to full-fledged development, 
            seamlessly transforming ideas into exceptional digital solutions.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {services.map((item, index) => (
            <Card
              key={index}
              icon={item.logo}
              title={item.title}
              desc={item.desc}
              color={item.activeColor}
              link={item.link}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

function Card({ icon, title, desc, color, link }) {
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <Link 
      to={link} 
      target="blank"
      className="group relative bg-white border border-gray-200 rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:border-gray-300 hover:-translate-y-2 cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Hover Effect Border */}
      <div 
        className="absolute inset-0 rounded-2xl transition-all duration-300"
        style={{
          background: isHovered ? `linear-gradient(135deg, ${color}20, ${color}10)` : 'transparent'
        }}
      />
      
      <div className="relative z-10 flex flex-col gap-6">
        {/* Icon */}
        <div className="w-16 h-16 bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
          <img src={icon} alt={title} className="w-10 h-10" />
        </div>
        
        {/* Content */}
        <div>
          <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-gray-700 transition-colors duration-300">
            {title}
          </h3>
          <p className="text-gray-600 leading-relaxed">
            {desc}
          </p>
        </div>
        
        {/* Arrow Icon */}
        <div className="flex justify-end">
          <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center group-hover:bg-gray-200 transition-colors duration-300">
            <svg className="w-4 h-4 text-gray-600 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default Launch;

